import React, {useState, useEffect} from 'react';
import { ReactComponent as IconoOrdenar } from './../imagenes/ordenar.svg';
import {
	ContenedorSubtituloPequeño, ContenedorSubtitulo, Subtitulo, Descripcion, Lista, ElementoLista, ContenedorFiltros,Contenedor, Formulario,
	Input, ContenedorBoton,Btn, BotonAccion, ContenedorLista,ContenedorItinerario,ContenedorInputConIcono
} from '../elementos/ElementosDeFormulario';
import Boton from './../elementos/Boton';
import {ReactComponent as IconoPlus} from './../imagenes/plus.svg';
import {db} from '../firebase/firebaseConfig';
import { ref, push, set, update } from "firebase/database";
import { ReactComponent as IconoEstado } from '.././imagenes/estado.svg';
import { ReactComponent as IconoPasajero } from '.././imagenes/pasajero.svg';
import Iconotipo from '../elementos/IconoItinerario';
import Alerta from './../elementos/Alerta';
import { useAuth } from './../contextos/AuthContext';
import {format} from 'date-fns';
import es from "date-fns/locale/es";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faIdCard,faPhone,faEnvelope,faUser, faToggleOn,faAddressCard,faPalette,faCar,faCarTunnel,faTrailer, faLocationCrosshairs} from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';


const FormularioCancelarViaje = ({id, viaje, itinerario, cambiarItinerario, listadoPasajeros, cambiarListadoPasajeros}) => {
    const {usuario} = useAuth();
    const navigate = useNavigate();
    const [fechahoraviaje, cambiarFechahoraviaje] = useState ('Ingrese Fecha y hora de Viaje');
    const [fecha_hora_creacion, cambiarfecha_hora_creacion] = useState (new Date());
    const [cliente, cambiarCliente] = useState ('Seleccione Cliente');
    const [estado, cambiarEstado] = useState ('Programado');
    const [movil, CambiarMovil] = useState({numero:"Movil"});
    const [comentarios, CambiarComentarios] = useState('');
    const [ordenado, CambiarOrdenado] = useState('');
    const [alerta, cambiarAlerta] = useState({});
    const [estadoAlerta, cambiarEstadoAlerta] = useState(false);
    const[fechaFormateada,cambiafechaFormateada] = useState();


    const formatearFecha = (fecha = new Date()) => {
        return format((fecha), "EE dd 'de' MMMM 'de' yyyy 'a las' h:mm aa", {locale: es});
    }
      
    useEffect (()=>{
    viaje.empresa && cambiarCliente(viaje.empresa);
    viaje.numero_m && CambiarMovil({
        numero:  viaje.numero_m,
        color: viaje.color_m,
        nombre: viaje.nombre_m,
        patente: viaje.patente_m,
        telefono: viaje.telefono_m
    });
    viaje.fecha_hora_programada && cambiarFechahoraviaje(new Date(viaje.fecha_hora_programada));
    viaje.itinerario && cambiarItinerario(Object.keys(viaje.itinerario).map(function (key) {return {id : key, ...viaje.itinerario[key]};}))
    viaje.pasajeros && cambiarListadoPasajeros(Object.keys(viaje.pasajeros).map(function (key) {return {id : key, ...viaje.pasajeros[key]};}))  
    viaje.estado && cambiarEstado(viaje.estado);
    viaje.fecha_hora_creacion && cambiarfecha_hora_creacion(new Date(viaje.fecha_hora_creacion));
    },[viaje]);


    const handleChange = (e) => {
		if(e.target.name === 'comentarios'){
			CambiarComentarios(e.target.value);
		}
	}

    const handleSubmit = async (e) => {
        e.preventDefault();
           update(ref(db,'projects/proj_6wVhReGA6EM5z4Jew4js7T/data/traslados/'+id),
            {   estado: 'Terminado',
                comentarios: viaje.comentarios+comentarios,
                modificador : usuario.uid
            })  
            cambiarEstadoAlerta(true);
                cambiarAlerta({
                    tipo: 'exito',
                    mensaje: 'El viaje fue Terminado'
                });
            cambiarItinerario([]);
            cambiarListadoPasajeros([]);
            setTimeout(() => {navigate('/')}, 2000)
    }

    useEffect (()=>{    
        if (fechahoraviaje !== 'Ingrese Fecha y hora de Viaje')
        {cambiafechaFormateada(formatearFecha(fechahoraviaje))}
        else
        {cambiafechaFormateada(fechahoraviaje)}
    },[fechahoraviaje]);  

    return (  
                
                    <Formulario onSubmit={handleSubmit}>
                        <Contenedor>
                        <main>   
                        <ContenedorSubtitulo><Subtitulo>&nbsp;&nbsp;Datos de Traslado</Subtitulo></ContenedorSubtitulo>
                        <ContenedorFiltros>
                        <Input name="movil" type="text" placeholder="movil" value={movil.numero} disabled = {true}/>
                        <Input name="cliente" type="text" placeholder="cliente" value={cliente} disabled = {true}/>
                        <Input name="fechahoraviaje" type="text" placeholder="fechahoraviaje" value={fechaFormateada} disabled = {true}/>
                        </ContenedorFiltros>
                        <ContenedorSubtitulo>
                            <Subtitulo>&nbsp;&nbsp;Itinerario de Viaje &nbsp;&nbsp;&nbsp;</Subtitulo>   
                        </ContenedorSubtitulo>
                        
                        <Lista>
                        {itinerario.map((pasajerol, index) =>{
                                return(
                                <ElementoLista key={pasajerol.id}>
                                    <ContenedorLista>
                                    <ContenedorItinerario>
                                    <Input name="orden_p" type="text" placeholder="Orden" value={pasajerol.orden} disabled = {true}/>
                                    <ContenedorInputConIcono><FontAwesomeIcon icon={faUser}/> <Input name="telefono_p" type="text" placeholder="Telefono Pasajero" value={pasajerol.nombre} disabled = {true}/> </ContenedorInputConIcono>
                                    <ContenedorInputConIcono><Iconotipo tipo={pasajerol.tipo}/><Input name="tipo_i" type="text" placeholder="Tipo Traslado" value={pasajerol.direccion} disabled = {true}/> </ContenedorInputConIcono>
                                    </ContenedorItinerario>
                                       </ContenedorLista>
                                </ElementoLista>
                                )
                        })}
                        </Lista> 
                        </main>
                        <ContenedorSubtituloPequeño><Subtitulo>Comentarios</Subtitulo></ContenedorSubtituloPequeño>                      
                        <Input name="Comentarios2" type="text" placeholder="Comentarios" value={viaje.comentarios} disabled = {true}/>
                        <ContenedorSubtituloPequeño><Subtitulo>Para Terminar el traslado ingrese detalle en comentarios y presione Terminar</Subtitulo></ContenedorSubtituloPequeño>
                        <Input type="text" name="comentarios" placeholder="Detalle de Traslado"value={comentarios} onChange={handleChange}/>
                        <ContenedorBoton><Boton as="button" primario conIcono type="submit"> Terminar Traslado &nbsp;&nbsp;<IconoPlus/></Boton></ContenedorBoton>
                        </Contenedor>
                        <Alerta 
                tipo={alerta.tipo}
                mensaje={alerta.mensaje}
                estadoAlerta={estadoAlerta}
                cambiarEstadoAlerta={cambiarEstadoAlerta}
            />
                    </Formulario>
    );
}
 
export default FormularioCancelarViaje;